<template>
  <div>
    <b-form-checkbox
      v-if="selectedGroups.includes('stats') || selectedGroups.length === 0"
      v-model="includeVersatile"
    >
      Include Versatile with Attack and Defense
    </b-form-checkbox>
    <UmDbDeckList
      :decks="decks"
      :includeVersatile="includeVersatile"
      :selectedGroups="selectedGroups"
    />
  </div>
</template>

<script type="text/javascript">
import UmDbDeckList from "@/components/UmDb/UmDbDeckList.vue";

export default {
  name: "UmDbDeckListView",
  metaInfo: {
    title: "Decks | UmDb"
  },
  components: { UmDbDeckList },
  data() {
    return {};
  },
  props: {
    selectedGroups: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    decks() {
      return this.$store.state.umDbDeckList.filter(
        deck => deck.cards.length > 0
      );
    },
    includeVersatile: {
      get() {
        if ("includeVersatile" in this.$store.state.userPreferences) {
          return this.$store.state.userPreferences.includeVersatile;
        }
        return false;
      },
      set(value) {
        this.$store.commit("setPreference", {
          key: "includeVersatile",
          value: value
        });
      }
    }
  }
};
</script>
